module.exports = __webpack_public_path__ + "img/legal-documents.77ac0f76.svg";